import React from 'react';

const StatusPill = ({ className, title, ...rest}) => {
   return <div className={`status-pill px-1 ${className}`} {...rest}>
      {title}
   </div>;
};

export default StatusPill;
